module.exports = __webpack_public_path__ + "static/img/onTheRight.98170dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onTheRight.png
// module id = rp+L
// module chunks = 24